import { APICarrierData } from 'types/api.types';
import { z } from 'zod';

// Zod validation schema for DASH report form
export const dashReportSchema = z.object({
  province: z.string().min(1, 'Province is required'),
  licenseNumber: z.string().min(1, 'License number is required'),
  carrier: z.any().optional().nullable(),
});

export type DashReportFormData = {
  province: string;
  licenseNumber: string;
  carrier?: APICarrierData | null;
};

// Initial form data with explicit typing
export const initialFormData: {
  province: string | null;
  licenseNumber: string;
  carrier: APICarrierData | null;
} = {
  province: null,
  licenseNumber: '',
  carrier: null,
};

export type DashReportFormErrors = Partial<
  Record<keyof DashReportFormData, string>
>;
